// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2JZ5o","title":"ClientReferral_title__XZa96","itemText":"ClientReferral_itemText__2EAw2"};